<template>
    <div class="tip-button" @click="$emit('click')">
        <span class="sp sp1" :class="icon"></span>
        <span class="sp sp2">{{ buttonText }}</span>
        <span class="sp sp3">{{ tipText }}</span>
    </div>
</template>

<script>
export default {
    name: 'TipButton',
    props: {
        icon: {
            type: String,
            default: ''
        },
        buttonText: {
            type: String,
            default: ''
        },
        tipText: {
            type: String,
            default: ''
        }
    },
    data() {
        return {

        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.tip-button {
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.02);
    background: rgba(255, 255, 255, 0.60);
    width: 68px;
    height: 28px;
    justify-content: center;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;

    .sp {
        &.sp1 {
            width: 14px;
            height: 14px;
            background-image: url(@/assets/images/common/button/history.png);
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }

        &.sp2 {
            color: #615E83;
            font-feature-settings: 'ss01' on, 'cv01' on, 'cv11' on;
            font-family: HYQiHei;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
        }

        &.sp3 {
            font-size: 12px;
            line-height: 18px;
            position: absolute;
            top: 100%;
            right: 0;
            visibility: hidden;
            width: max-content;
            padding: 4px 8px;
            transition: all 0.2s;
            white-space: nowrap;
            opacity: 0;
            color: #ffffff;
            border-radius: 5px;
            background-color: #333333;
            margin: 6px 0 0 0;
            z-index: 99999;

            &::before {
                position: absolute;
                top: -8px;
                right: 4px;
                width: 14px;
                height: 14px;
                content: '';
                transform: rotate(180deg);
                background-image: url(@/assets/images/common/tip-icon.svg);
                background-repeat: no-repeat;
                background-position: center;
            }
        }
    }

    @media screen and (max-width: 400px) {
        &:hover {
            .sp {
                &.sp3 {
                    visibility: visible;
                    opacity: 1;
                }
            }
        }

        width: auto;
        height: auto;
        background: initial;
        border: 0;

        .sp {
            &.sp1 {
                width: 24px;
                height: 24px;
                background-image: url(@/assets/images/common/button/history2.png);
            }

            &.sp2 {
                display: none;
            }
        }
    }
}
</style>